import flight from 'flightjs';

function zoomButton() {
    const ZOOM_OUT = -1;
    const ZOOM_IN = 1;

    this.attributes({
        zoomInButton: '[data-image-zoom-in]',
        zoomOutButton: '[data-image-zoom-out]',
    });

    this.disableButton = function(button) {
        this.select(button)
            .attr('data-disabled', true)
            .prop('disabled', true);
    };

    this.enableButton = function(button) {
        this.select(button)
            .removeAttr('data-disabled')
            .removeAttr('disabled');
    };

    this.updateButtons = function(e, data) {
        if (!data.canZoomOut) {
            this.disableButton('zoomOutButton');
        } else {
            this.enableButton('zoomOutButton');
        }

        if (!data.canZoomIn) {
            this.disableButton('zoomInButton');
        } else {
            this.enableButton('zoomInButton');
        }
    };

    this.clickZoomInButton = function() {
        const button = this.select('zoomInButton');

        if (button.is(':disabled') || button.attr('data-disabled') === 'true') {
            return;
        }

        this.trigger(document, 'uiImageZoomRequested', [ZOOM_IN]);
    };

    this.clickZoomOutButton = function() {
        const button = this.select('zoomOutButton');

        if (button.is(':disabled') || button.attr('data-disabled') === 'true') {
            return;
        }

        this.trigger(document, 'uiImageZoomRequested', [ZOOM_OUT]);
    };

    this.saveZoom = function(e, data) {
        document.cookie = `entry:zoom=${data.zoom}`;
    };

    this.after('initialize', function() {
        this.on('click', {
            zoomInButton: this.clickZoomInButton,
            zoomOutButton: this.clickZoomOutButton,
        });

        this.on(document, 'uiImageResized', this.updateButtons);
        this.on(document, 'uiImageZoomed', this.updateButtons);
        this.on(document, 'uiImageZoomed', this.saveZoom);
    });
}

export default flight.component(zoomButton);



// WEBPACK FOOTER //
// ./src/js/component_ui/zoom-controls.js